import { BasePlayerEvent } from '../../../reporter/constants';
import { MonitoredWindowEvents } from '../constants';
import ContentConfig from '../../../config/ContentConfig';

const { code } = MonitoredWindowEvents.visibilitychange;

export default function visibilityChangeHandler(
  event: BasePlayerEvent
): boolean {
  if (event.e != code) {
    return false;
  }
  if (typeof event.vis === 'undefined') {
    return true;
  }
  return !ContentConfig.getInstance().report.enableEngagementEvent;
}
